<template>
  <div
    id="Question"
    :class="
      question.user && question.is_answer_active ? 'general-account' : 'official-account'
    "
    :style="{
      marginBottom: mode == 'list' ? '12px' : '0px',
      paddingBottom: mode == 'detail' ? '24px' : '0px',
    }"
  >
    <div class="question-section not-full">
      <div class="profile" @click="goDetail">
        <Profile
          v-if="question && question.user"
          :user="question.user"
          :created="question.time"
        />
      </div>
      <pre
        class="content"
        @click="goDetail"
        v-line-clamp="lineClamp"
        v-html="question.content"
      ></pre>
    </div>
    <div
      class="answer-section not-full"
      @click="goDetail"
      v-if="
        mode == 'list' &&
        question.answer &&
        question.user &&
        question.is_answer_active
      "
    >
      <div class="arrow">
        <div class="nieum"></div>
      </div>
      <div class="answer">
        <Answer :mode="mode" :answer="question.answer" />
      </div>
    </div>
    <div class="options-section not-full">
      <div
        :class="{
          'options-list': mode == 'list',
          'options-detail': mode == 'detail',
        }"
      >
        <div class="left">
          <LikeCount
            :key="'LikeCount' + question.uuid"
            :question="question"
            v-if="question"
          />
        </div>
        <div class="line" v-if="question.user && question.is_answer_active">
          <div></div>
        </div>
        <div
          class="right"
          @click="goDetail"
          v-if="question.user && question.is_answer_active"
        >
          <Reply v-if="mode == 'list'" :count="question.count_answers" />
          <Edit
            v-if="
              mode == 'detail' && question && user.uuid == question.user.uuid
            "
            :question="question"
            @editQuestion="editQuestion"
            @removeQuestion="removeQuestion"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Services
import AuthService from '@/service/auth/AuthService'

// Components Section
import Profile from './Profile'
import LikeCount from './LikeCount'
import Edit from './Edit'
import Reply from './Reply'
import Answer from './Answer'

// Third Party
// import VClamp from 'vue-clamp'

// Variable Section
// let self

export default {
  name: 'TalkItem',
  props: ['mode', 'question', 'isLast', 'clamp'],
  components: {
    LikeCount,
    Profile,
    Edit,
    Reply,
    Answer,
  },
  data: function () {
    return {
      user: null,
      lineClamp: this.clamp ? this.clamp : this.mode === 'detail' ? 100 : 5
    }
  },
  computed: {},
  created() {
    this.user = AuthService.getProfile()
  },
  destroyed() {},
  methods: {
    goDetail() {
      if (this.$route.name !== 'talks') {
        return
      }
      this.$router.push({
        name: 'talks/:uuid',
        params: { uuid: this.question.uuid },
      })
    },
    editQuestion() {
      this.$emit('editQuestion', this.question)
    },
    removeQuestion() {
      this.$emit('removeQuestion', this.question)
    },
  },
  chimera: {
    posts: 'https://jsonplaceholder.typicode.com/posts',
  },
}
</script>

<style lang="scss" scoped>
#Question {
  width: 100%;
  padding-top: 16px;
  background-color: #ffffff;

  &.official-account .left {
    width: 100% !important;
  }

  .question-section {
    width: 100%;
    .profile {
      width: 100%;
      margin-bottom: 17px;
    }
    .content {
      float: none;
      width: 100%;
      font-weight: 700;
      font-size: 16px;
      line-height: 1.44;
      color: #333333;
      white-space: pre-line;
    }
  }

  .answer-section {
    margin-top: 18px;
    .arrow {
      width: 22px;
      .nieum {
        width: 13px;
        height: 15px;
        border-style: solid;
        border-color: #b9c1cc;
        border-left-width: 1px;
        border-bottom-width: 1px;
        margin-top: 4px;
      }
    }
    .answer {
      width: calc(100% - 22px);
    }
  }

  .options-section {
    width: 100%;
    margin-top: 20px;
    .options {
      .left {
        float: left;
      }

      .right {
        float: right;
      }
      &-detail {
        .left {
          float: left;
        }

        .right {
          float: right;
        }
      }
      &-list {
        width: 100%;
        height: 50px;
        border-top: solid 1px #e1e9f3;
        .left {
          width: 50%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .line {
          width: 1px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          div {
            width: 1px;
            height: 20px;
            background-color: #d7e1ea;
          }
        }
        .right {
          width: calc(50% - 1px);
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      &-detail {
        width: 100%;
      }
    }
  }
}
</style>
